import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Sidebar from './components/Sidebar.vue';
import Header from './components/Header.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Auth',
      component: require('./views/Auth').default,
    },
    {
      path: '/login/external_provider',
      name: 'ExternalAuth',
      component: require('./views/Auth').default,
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: require('./views/ForgotPassword').default,
    },
    {
      path: '/',
      name: 'Dashboard',
      components: {
        default: require('./views/Dashboard').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/tasks',
      name: 'Tasks',
      components: {
        default: require('./views/Taskview').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/projects',
      name: 'Projects',
      components: {
        default: require('./views/Projects').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/projects/:id',
      name: 'ProjectDetail',
      components: {
        default: require('./views/ProjectDetail').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/reports',
      name: 'Reports',
      components: {
        default: require('./views/Reports').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/resourcing',
      name: 'Resourcing',
      components: {
        default: require('./views/Resourcing').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/analytics',
      name: 'Analytics',
      components: {
        default: require('./views/QuickSightEmbed').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/suppliers',
      name: 'Suppliers',
      components: {
        default: require('./views/Suppliers').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/people',
      name: 'People',
      components: {
        default: require('./views/People').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
        superAdminOnly: true,
      },
    },
    {
      path: '/organisations',
      name: 'Organisations',
      components: {
        default: require('./views/Organisations').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
        superAdminOnly: true,
      },
    },
    {
      path: '/self-service/:id?',
      name: 'SelfService',
      components: require('./views/SelfService.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/project-templates',
      name: 'ProjectTemplates',
      components: {
        default: require('./views/ProjectTemplates').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/project-templates/:id',
      name: 'ProjectTemplatesDetail',
      components: {
        default: require('./views/ProjectTemplateDetail').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/approvals',
      name: 'PendingBenefitApprovals',
      components: {
        default: require('./views/PendingBenefitApprovals').default,
        sidebar: Sidebar,
        header: Header,
      },
      meta: {
        requiresAuth: true,
        allowedJobTitles: ['Finance']
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  // close the Action Tray
  store.dispatch('setCurrentActionId', -1);
  store.dispatch('setActionTrayVisibility', false);
  store.dispatch('setActions', []);
  store.dispatch('setSearchTerm', '');
  store.dispatch('setBurgerMenuOpen', false);

  // scroll to top of page
  document.querySelector('#app').scrollTo(0, 0);

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const superAdminOnly = to.matched.some(record => record.meta.superAdminOnly);
  const allowedJobTitles = to.meta ? to.meta.allowedJobTitles : undefined;

  const logged_in = store.getters.id_token;

  const user = store.getters.app_user;
  const userRole = user ? user.role : undefined;
  const userJobTitle = user ? user.jobTitle : undefined;

  const homeRoute = (user && user.role && user.role === 'Stakeholder') ? '/self-service' : '/projects';

  // Auth check
  if (requiresAuth) {
    if (!logged_in) {
      const loginRoute = { name: 'Auth'};

      // User needs to log in then we can redirect them to where they were going
      if(to.name === 'PendingBenefitApprovals') loginRoute.query = { redirectTo: to.fullPath };

      next(loginRoute);
      return;
    };
  } else if (to.path === 'login' && logged_in){
      next(homeRoute);
      return;
  }

  // SuperAdmin check
  if (superAdminOnly && userRole !== 'SuperAdmin') {
    next(homeRoute);
    return;
  };

  // Self-Service check
  if (userRole === 'Stakeholder') {
    if (to.name !== 'SelfService') {
      next(homeRoute);
      return;
    };
  } else {
    if (to.name === 'SelfService') {
      next(homeRoute);
      return;
    };
  }

  // Job Title check
  if (allowedJobTitles && !allowedJobTitles.includes(userJobTitle)) {
    next(homeRoute);
    return;
  };

  next();
});

export default router;
